export class Password {
    constructor(public password: string) {
    }
}
